import React, { useEffect, useState } from "react";
import { Chip } from "@mui/material";

const Present1Widget = ({ widget, onValueUpdate }) => {
  const [isPresent, setIsPresent] = useState(false);

  useEffect(() => {
    if (widget?.items?.$w1) {
      setIsPresent(widget.items.$w1.value === "present");
    }
  }, [widget]);

  const getStatusText = () => {
    return isPresent ? "present" : "clear";
  };

  const getChipColor = () => {
    return isPresent ? "secondary" : "default";
  };

  return (
    <Chip
      label={getStatusText()}
      color={getChipColor()}
      variant="contained"
      sx={{
        width: "100%",
        fontWeight: 500,
        fontSize: "0.875rem",
        textTransform: "capitalize",
      }}
    />
  );
};

export default Present1Widget;
